/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PayMateTransactionDto
 */
export interface PayMateTransactionDto {
    /**
     *
     * @type {number}
     * @memberof PayMateTransactionDto
     */
    payMateSessionId?: number;
    /**
     *
     * @type {string}
     * @memberof PayMateTransactionDto
     */
    chargerDeviceIdentity?: string;
    /**
     *
     * @type {number}
     * @memberof PayMateTransactionDto
     */
    connectorIndex?: number;
    /**
     *
     * @type {boolean}
     * @memberof PayMateTransactionDto
     */
    externalSession?: boolean;
    /**
     *
     * @type {string}
     * @memberof PayMateTransactionDto
     */
    status?: PayMateTransactionDtoStatusEnum;
    /**
     *
     * @type {number}
     * @memberof PayMateTransactionDto
     */
    transactionId?: number;
    /**
     *
     * @type {string}
     * @memberof PayMateTransactionDto
     */
    paymentId?: string;
    /**
     *
     * @type {string}
     * @memberof PayMateTransactionDto
     */
    currencyCode?: string;
    /**
     *
     * @type {number}
     * @memberof PayMateTransactionDto
     */
    preAuthAmountCharged?: number;
    /**
     *
     * @type {number}
     * @memberof PayMateTransactionDto
     */
    finalAmountCharged?: number;
    /**
     *
     * @type {Date}
     * @memberof PayMateTransactionDto
     */
    sessionStart?: Date;
    /**
     *
     * @type {Date}
     * @memberof PayMateTransactionDto
     */
    sessionEnd?: Date;
    /**
     *
     * @type {string}
     * @memberof PayMateTransactionDto
     */
    sessionTrackingUrl?: string;
    /**
     *
     * @type {string}
     * @memberof PayMateTransactionDto
     */
    message?: string;
}

/**
 * @export
 */
export const PayMateTransactionDtoStatusEnum = {
    Pending: "Pending",
    Active: "Active",
    Completed: "Completed",
    Aborted: "Aborted",
    Finishing: "Finishing",
} as const;
export type PayMateTransactionDtoStatusEnum =
    (typeof PayMateTransactionDtoStatusEnum)[keyof typeof PayMateTransactionDtoStatusEnum];

/**
 * Check if a given object implements the PayMateTransactionDto interface.
 */
export function instanceOfPayMateTransactionDto(
    value: object,
): value is PayMateTransactionDto {
    return true;
}

export function PayMateTransactionDtoFromJSON(
    json: any,
): PayMateTransactionDto {
    return PayMateTransactionDtoFromJSONTyped(json, false);
}

export function PayMateTransactionDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PayMateTransactionDto {
    if (json == null) {
        return json;
    }
    return {
        payMateSessionId:
            json["payMateSessionId"] == null
                ? undefined
                : json["payMateSessionId"],
        chargerDeviceIdentity:
            json["chargerDeviceIdentity"] == null
                ? undefined
                : json["chargerDeviceIdentity"],
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        externalSession:
            json["externalSession"] == null
                ? undefined
                : json["externalSession"],
        status: json["status"] == null ? undefined : json["status"],
        transactionId:
            json["transactionId"] == null ? undefined : json["transactionId"],
        paymentId: json["paymentId"] == null ? undefined : json["paymentId"],
        currencyCode:
            json["currencyCode"] == null ? undefined : json["currencyCode"],
        preAuthAmountCharged:
            json["preAuthAmountCharged"] == null
                ? undefined
                : json["preAuthAmountCharged"],
        finalAmountCharged:
            json["finalAmountCharged"] == null
                ? undefined
                : json["finalAmountCharged"],
        sessionStart:
            json["sessionStart"] == null
                ? undefined
                : new Date(json["sessionStart"]),
        sessionEnd:
            json["sessionEnd"] == null
                ? undefined
                : new Date(json["sessionEnd"]),
        sessionTrackingUrl:
            json["sessionTrackingUrl"] == null
                ? undefined
                : json["sessionTrackingUrl"],
        message: json["message"] == null ? undefined : json["message"],
    };
}

export function PayMateTransactionDtoToJSON(
    value?: PayMateTransactionDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        payMateSessionId: value["payMateSessionId"],
        chargerDeviceIdentity: value["chargerDeviceIdentity"],
        connectorIndex: value["connectorIndex"],
        externalSession: value["externalSession"],
        status: value["status"],
        transactionId: value["transactionId"],
        paymentId: value["paymentId"],
        currencyCode: value["currencyCode"],
        preAuthAmountCharged: value["preAuthAmountCharged"],
        finalAmountCharged: value["finalAmountCharged"],
        sessionStart:
            value["sessionStart"] == null
                ? undefined
                : value["sessionStart"].toISOString(),
        sessionEnd:
            value["sessionEnd"] == null
                ? undefined
                : value["sessionEnd"].toISOString(),
        sessionTrackingUrl: value["sessionTrackingUrl"],
        message: value["message"],
    };
}
